import React from 'react'
import Banner from './components/Banner'
import { CustomButton } from 'styles/global'
import { GiCheckMark } from 'react-icons/gi'
import Navbar from 'components/Navbar'
import { CorpoConteudo } from 'layouts/simple/style'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const CartaoConsignado = () => {
  return (
    <>
      <Navbar />
      <CorpoConteudo minHeight="calc(100vh - 60px)">
        <Banner
          contentBanner={
            <div className="infos-cartao-consignado">
              <div className="container container-produto justify-content-center justify-content-md-between">
                <div className="d-flex flex-column justify-content-center gap-5">
                  <h1>
                    Cartão de Crédito <br /> Consignado com taxas a <br />
                    partir de 2,73% ao mês.
                  </h1>
                  <div>
                    <h2 className="linha-1">
                      Limite de até 1,6x do benefício e
                    </h2>
                    <h2 className="linha-2">saque disponível em dinheiro.</h2>
                  </div>
                  <div className="d-flex justify-content-center w-100">
                    <HashLink
                      to="/#iniciar-simulacao"
                      className="w-100 d-flex justify-content-center no-styled-link"
                      smooth
                      scroll={(el) => {
                        scrollWithOffset(el, 300)
                      }}
                    >
                      <CustomButton
                        background="var(--verde-riber)"
                        borderRadius={25}
                        height="56px"
                        fontSize="30px"
                        maxWidth="350px"
                        width="100%"
                      >
                        Simule agora
                      </CustomButton>
                    </HashLink>
                  </div>
                </div>
                <div className="d-lg-flex d-none flex-column justify-content-center">
                  <img
                    className="img-banner-produto"
                    src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/cartao_consignado_1.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="container">
                <div className="d-flex gap-3">
                  <span className="tips">
                    <GiCheckMark className="icon" />
                    Sem anuidade
                  </span>
                  <span className="tips">
                    <GiCheckMark className="icon" />
                    Descontos em farmácias
                  </span>
                  <span className="tips">
                    <GiCheckMark className="icon" />
                    Aprovado para negativados
                  </span>
                  <span className="tips">
                    <GiCheckMark className="icon" />
                    Saque de até 70% do limite do cartão
                  </span>
                </div>
              </div>
            </div>
          }
        />
      </CorpoConteudo>
    </>
  )
}

export default CartaoConsignado
